module.exports = __webpack_public_path__ + "img/nuestros-servicios_3-pasos-01pajarillo.b830e9f2.svg";